import { useDispatch, useSelector } from "react-redux";
import {
  capsFirstLetter,
  tranformBusinessData,
} from "./utils/UtilityFunctions";

const useAppDispatch = () => useDispatch();
const useRegisterUserData = () => useSelector((state) => state.registerReducer);
const useLoginUserData = () => useSelector((state) => state.loginReducer);
const useAdminLoginData = () => useSelector((state) => state.adminLoginReducer);
const useUserData = () => useSelector((state) => state.utilityReducer.userData);
const useSelectedCity = () =>
  useSelector((state) => state.utilityReducer.selectedCity);

const useVenueData = () => useSelector((state) => state.venueReducer);
const useVenueImageData = () => useSelector((state) => state.venueImageReducer);
const useGetBusinessData = () => useSelector((state) => state.businessReducer);
const useEnquiryData = () => useSelector((state) => state.enquiryReducer);
const useReviewData = () => useSelector((state) => state.reviewReducer);
const useGetUserData = () =>
  useSelector((state) => state.userReducer.getUsersData);
const useVendorData = () => useSelector((state) => state.vendorReducer);
const useVendorProfileData = () =>
  useSelector((state) => state.vendorProfileReducer);
const useMailData = () => useSelector((state) => state.mailReducer);
const useResetPasswordData = () =>
  useSelector((state) => state.resetPasswordReducer);
const useUserReducer = () => useSelector((state) => state.userReducer);
const useVendorTypes = (businessesList, all = false, selectedCity = "") => {
  const filteredBusinesses = selectedCity
    ? businessesList?.filter(
        (item) => item?.city?.toLowerCase() === selectedCity?.toLowerCase(),
      )
    : businessesList;

  const vendorTypes = [
    ...new Set(
      tranformBusinessData(filteredBusinesses, false).map((item) =>
        capsFirstLetter(item.type),
      ),
    ),
  ];

  const formattedTypes = vendorTypes.map((type) =>
    selectedCity ? `${type} in ${selectedCity}` : type,
  );

  return all
    ? [
        ...formattedTypes,
        selectedCity
          ? `Explore All Vendors in ${selectedCity}`
          : "Explore All Vendors",
      ]
    : formattedTypes;
};
const useRealWeddingReducer = () =>
  useSelector((state) => state.realWeddingReducer);
export {
  useAppDispatch,
  useRegisterUserData,
  useLoginUserData,
  useAdminLoginData,
  useUserData,
  useSelectedCity,
  useEnquiryData,
  useReviewData,
  useVenueData,
  useVenueImageData,
  useGetBusinessData,
  useGetUserData,
  useVendorData,
  useVendorProfileData,
  useMailData,
  useResetPasswordData,
  useVendorTypes,
  useUserReducer,
  useRealWeddingReducer,
};
